// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-library"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 9H21L19.2 21H4.8L3 9Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13.5 15L11.5 16.5V13.5L13.5 15Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 6H19M7 3H17M3 9H21L19.2 21H4.8L3 9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.5 15L11.5 16.5V13.5L13.5 15Z","strokeWidth":"props.strokeWidth"}}]}]};

const VideoLibraryIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-library',
    ref,
    icon: element,
  },
));

VideoLibraryIcon.displayName = 'VideoLibraryIcon';

export default VideoLibraryIcon;
